import UPSwitch from './UPSwitch';

export default UPSwitch;
